import { render, staticRenderFns } from "./ViewLocationPage.vue?vue&type=template&id=4ae86536"
import script from "./ViewLocationPage.vue?vue&type=script&lang=js"
export * from "./ViewLocationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports